const SITE = {
  AT: "AT",
  HOS: "HOS",
  HUL: "HUL",
  LJUNGBY: "LJUNGBY",
  UMEA: "UMEA",
} as const;

const ENVIRONMENT_CODE = process.env.REACT_APP_ENVIRONMENT_CODE;

export const isAT = () => ENVIRONMENT_CODE === SITE.AT;

export const isHOS = () => ENVIRONMENT_CODE === SITE.HOS;

export const isHUL = () => ENVIRONMENT_CODE === SITE.HUL;

export const isLJUNGBY = () => ENVIRONMENT_CODE === SITE.LJUNGBY;

export const isUMEA = () => ENVIRONMENT_CODE === SITE.UMEA;
